// extracted by mini-css-extract-plugin
module.exports = {"container":"eW","image":"eX","title":"eY","desc":"eZ"};